import React from 'react'
import { CardContent, styled, SxProps, Theme } from '@mui/material'
import CardFormHeader from '../../Card/CardFormHeader'

const CardContentInformation = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
    paddingRight: 0,
    marginTop: theme.spacing(2),
  },
}))

interface Props {
  header: React.ReactNode
  headerContainerProps?: (theme: Theme) => Record<string, unknown>
  sectionId?: string
  children?: React.ReactNode
  cardContentSx?: SxProps<Theme>
}

const InfoSection: React.FC<Props> = ({
  header,
  headerContainerProps,
  sectionId,
  children,
  cardContentSx,
}) => {
  return (
    <>
      <CardFormHeader
        header={header}
        headerContainerProps={headerContainerProps}
      />
      <CardContentInformation sx={cardContentSx}>
        <section aria-labelledby={sectionId}>{children}</section>
      </CardContentInformation>
    </>
  )
}

export default InfoSection
